import { ActionContext, Module } from 'vuex';
import { GridsState, RootState } from '@/store/types';
import { GridParams } from '@/types';

type Context = ActionContext<GridsState, RootState>;

export const grids: Module<GridsState, RootState> = {
    namespaced: true,
    state: {
        saved: {},
    },
    actions: {
        saveGrid({ commit }: Context, payload: { key: string; data: GridParams<unknown> }): void {
            commit('saveGrid', payload);
        },
        loadGrid({ state }: Context, payload: { key: string; }): GridParams<unknown> {
            return { ...state.saved[payload.key] };
        },
    },
    mutations: {
        saveGrid(state: GridsState, payload: { key: string; data: GridParams<unknown> }): void {
            state.saved[payload.key] = payload.data;
        },
    },
};
